import { emptyFn } from './helper';
var CHECK_POSITION_INTERVAL = 100;
export function checkPositionChange(dom, onChange) {
    if (!dom) {
        return emptyFn;
    }
    var prevPosition = dom.getBoundingClientRect();
    var checkTimer = setInterval(function () {
        var position = dom.getBoundingClientRect();
        if (Math.abs(prevPosition.left - position.left) > 1
            || Math.abs(prevPosition.top - position.top) > 1) {
            onChange();
        }
        prevPosition = position;
    }, CHECK_POSITION_INTERVAL);
    return function () { return clearInterval(checkTimer); };
}
